import React from "react";

import "./src/styles/main.scss";
import { AuthManager } from "./src/context/auth";

export const wrapRootElement = ({ element }) => (
  <AuthManager>{element}</AuthManager>
);
